export default "__VITE_ASSET__DgVr6Z2U__"